import React from "react";

export const Vuokraus = (props) => {
  return (
    <div id="vuokraus" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Vuokrattavat</h2>
        </div>
        <div className="row" style={{ display: 'inline-flex', justifyContent: 'center' }}>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-xs-6 col-md-3">
                  {" "}
                  {d.items && d.items.length > 0 && d.items[0].image ? (
                    <div>
                      <img src={`/img/${d.items[0].image.split('/').pop()}.jpeg`} alt={d.title} style={{ width: '100%', height: 'auto'}} />
                    </div>
                  ) : null}
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Lataa..."}
        </div>
      </div>
    </div>
  );
};
